// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard-entrants-info-text-container {
  width: 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
}

.leaderboard-entrants-info-text-container.centered {
  align-items: center;
  gap: 9px;
}

.leaderboard-entrants-header,
.leaderboard-entrants-text {
  text-decoration: underline;
  align-self: stretch;
  position: relative;
  font-weight: 500;
  color: inherit;
}

.leaderboard-entrants-header {
  text-decoration: underline;
}

.leaderboard-entrants-text {
  text-decoration: none;
}

.leaderboard-entrants-header.eliminated,
.leaderboard-entrants-text.eliminated {
  display: inline-block;
  min-width: 60px;
}

.leaderboard-entrants-info {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 50px;
}

.leaderboard-entrants-info-container {
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 32px;
  box-sizing: border-box;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  font-size: 12px;
  color: #002129;
  font-family: Inter;
}`, "",{"version":3,"sources":["webpack://./src/components/NFLSurvivor/NFLSurvivorStyles/SurvivorLeaderboard.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;AACJ;;AAEE;EACE,mBAAA;EACA,QAAA;AACJ;;AAEE;;EAEE,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEE;EACE,0BAAA;AACJ;;AAEE;EACE,qBAAA;AACJ;;AAEE;;EAEE,qBAAA;EACA,eAAA;AACJ;;AAEE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AACJ;;AAEE;EACE,WAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AACJ","sourcesContent":[".leaderboard-entrants-info-text-container {\n    width: 60px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 12px;\n  }\n  \n  .leaderboard-entrants-info-text-container.centered {\n    align-items: center;\n    gap: 9px;\n  }\n  \n  .leaderboard-entrants-header,\n  .leaderboard-entrants-text {\n    text-decoration: underline;\n    align-self: stretch;\n    position: relative;\n    font-weight: 500;\n    color: inherit;\n  }\n  \n  .leaderboard-entrants-header {\n    text-decoration: underline;\n  }\n  \n  .leaderboard-entrants-text {\n    text-decoration: none;\n  }\n  \n  .leaderboard-entrants-header.eliminated,\n  .leaderboard-entrants-text.eliminated {\n    display: inline-block;\n    min-width: 60px;\n  }\n  \n  .leaderboard-entrants-info {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 50px;\n  }\n  \n  .leaderboard-entrants-info-container {\n    width: 100%;\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 32px;\n    box-sizing: border-box;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    font-size: 12px;\n    color: #002129;\n    font-family: Inter;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
